import { icon as leafletIcon, tileLayer } from "leaflet";

/**
 * Configuraciones centralizadas para mapas con Leaflet
 */

// Configuración por defecto de íconos
export const DEFAULT_ICON_CONFIG = {
	iconSize: [38, 38] as [number, number],
	iconAnchor: [17, 38] as [number, number],
	popupAnchor: [0, -40] as [number, number],
};

// Íconos de pins predefinidos
export const MAP_PIN_ICONS = {
	pin01: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_01.png",
	}),
	pin02: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_02.png",
	}),
	pin03: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_03.png",
	}),
	pin04: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_04.png",
	}),
	pin05: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_05.png",
	}),
	pin06: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_06.png",
	}),
	pin07: leafletIcon({
		...DEFAULT_ICON_CONFIG,
		iconUrl: "../../../../../assets/icons/pin/pin_07.png",
	}),
} as const;

// Mapeo de tipos de instalación a íconos
export const INSTALLATION_TYPE_TO_ICON = {
	EBAR: MAP_PIN_ICONS.pin03,
	EDAR: MAP_PIN_ICONS.pin04,
	ETAP: MAP_PIN_ICONS.pin02,
	IDAM: MAP_PIN_ICONS.pin01,
	REDI: MAP_PIN_ICONS.pin05,
	OFICINA: MAP_PIN_ICONS.pin06,
	default: MAP_PIN_ICONS.pin07,
} as const;

// Configuración por defecto del mapa
export const DEFAULT_MAP_OPTIONS = {
	layers: [
		tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
			maxZoom: 18,
			minZoom: 3,
			attribution: "",
		}),
	],
	zoomControl: false,
	attributionControl: false,
};

// Configuración de vista por defecto
export const DEFAULT_VIEW_OPTIONS = {
	zoom: 6,
	minZoom: 3,
	maxZoom: 18,
};

// Coordenadas por defecto para España
export const DEFAULT_SPAIN_COORDINATES = {
	latitude: 40.463667,
	longitude: -3.74922,
	zoom: 6,
} as const;

/**
 * Función helper para obtener el ícono según el tipo de instalación
 */
export function getIconByInstallationType(tipo: string | null | undefined) {
	const normalizedType =
		tipo?.toUpperCase() as keyof typeof INSTALLATION_TYPE_TO_ICON;
	return (
		INSTALLATION_TYPE_TO_ICON[normalizedType] ||
		INSTALLATION_TYPE_TO_ICON.default
	);
}

/**
 * Función helper para crear configuración básica de mapa
 */
export function createBasicMapOptions(includeAttribution = false) {
	return {
		...DEFAULT_MAP_OPTIONS,
		attributionControl: includeAttribution,
	};
}
